const CART_CONSTANTS = {
    LOAD_CART_ACTION: 'LOAD_CART',
    CART_LOADED_ACTION: 'CART_LOADED',
    CART_LOADED_ERROR_ACTION: 'CART_LOADED_ERROR',
    GET_CART_API_PATH: '/cart/get/',
};

export default CART_CONSTANTS;
